<template>
  <div>
    <h2>Google Sign-In</h2>
    <button @click="signInWithGoogle">Sign In with Google</button>
    <!-- Vous pouvez également ajouter une section pour les messages d'erreur ici -->
    <p v-if="errorMessage">{{ errorMessage }}</p>
  </div>
</template>

<script>
//import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';

export default {
  data() {
    return {
      errorMessage: '', // Pour stocker les messages d'erreur
    };
  },
  methods: {
  //   async signInWithGoogle() {
  //     // const auth = getAuth();
  //     // const provider = new GoogleAuthProvider();

  //  //   try {
  //     //  const result = await signInWithPopup(auth, provider);
  //     //  const user = result.user;
  //    //   console.log('Logged in user:', user);

  //       // Redirigez ou faites quelque chose après une connexion réussie
  //       // par exemple, changer de route ou actualiser l'état de l'utilisateur dans votre store
  //       this.$router.push('/home'); // Assurez-vous que le chemin existe dans votre router
  //     } catch (error) {
  //       console.error('Google sign-in failed:', error);
  //       this.errorMessage = 'Failed to sign in: ' + error.message;
  //     }
  //  }
  }
};
</script>
